<template lang="pug">
ul.stars(
  @mouseleave="hover = 0"
  @click="$emit('click', hover)"
)
  li.star(
    v-for="star, index in stars"
    class="star"
    @mouseover="hover = index + 1"
  )
    img(v-if="star", src="./star-active.svg")
    img(v-else, src="./star.svg")
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 5,
    },

    value: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    hover: 0,
  }),

  computed: {
    rate() {
      return Math.max(Math.min(this.max, this.value), 0);
    },

    stars() {
      let stars = [];
      for (let i = 0; i < this.max; i++) {
        stars.push(i < this.rate);
      }
      return stars;
    },
  },

  watch: {
    hover(newValue) {
      this.$emit('hover', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.stars {
  overflow: hidden;
  display: block;
  white-space: nowrap;

  .star {
    display: inline-block;
    height: 100%;
    position: relative;

    img {
      height: 80%;
      width: auto;
    }
  }

  .active {
  }
}
</style>


// WEBPACK FOOTER //
// Default.vue?6bb40402